import { Breadcrumb, Button, Form, Grid, Icon, Image, Menu, Segment } from 'semantic-ui-react';
import { Formik } from 'formik';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../redux/actions';
import { TextField } from '../../common/FormFields';
import * as selectors from '../../../redux/selectors';
import PageContainer from '../../common/PageContainer';
import { firmValidationSchema } from '../adslot.constants';
import { Link } from 'react-router-dom';
import './Firm.scss';
import CloudinaryUploadWidget from '../CloudinaryUploadWidget';
import SitesDropDown from '../SitesDropDown';

const FirmPage = ({ match, firm, getFirmById, updateFirm }) => {
  const id = match.params.id;

  useEffect(() => getFirmById(id), [id]);

  const getPage = () => (
    <Formik
      initialValues={{ siteIds: [], ...firm }}
      enableReinitialize
      validationSchema={firmValidationSchema}
      onSubmit={updateFirm}
    >
      {formik => (
        <PageContainer>
          <Breadcrumb>
            <Breadcrumb.Section>
              <Link to="/firm">Firms</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>Edit Firm</Breadcrumb.Section>
          </Breadcrumb>

          <Menu borderless attached="top">
            <Menu.Item header>
              <Icon name="building outline" />
              {firm.name}
            </Menu.Item>
          </Menu>

          <Segment attached>
            <Form onSubmit={formik.handleSubmit}>
              <Grid stackable>
                <Grid.Column tablet="16" mobile="16" computer="10">
                  <TextField
                    label="Firm"
                    name="name"
                    formik={formik}
                    value={formik.values.name || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    errorMessage={formik.errors.name}
                  />

                  {formik.values.logoUrl1 && (
                    <Image src={formik.values.logoUrl1} size="medium" style={{ marginBottom: '1rem' }} />
                  )}

                  <Grid columns="2" style={{ marginBottom: 0 }}>
                    <Grid.Column width="12">
                      <TextField
                        label="Logo"
                        name="logoUrl1"
                        formik={formik}
                        value={formik.values.logoUrl1 || ''}
                        onChange={formik.handleChange}
                        error={formik.touched.logoUrl1 && Boolean(formik.errors.logoUrl1)}
                        errorMessage={formik.errors.logoUrl1}
                      />
                    </Grid.Column>
                    <Grid.Column style={{ paddingTop: 37 }} width="4">
                      <CloudinaryUploadWidget formik={formik} fieldName={'logoUrl1'} />
                    </Grid.Column>
                  </Grid>

                  {/* <TextField
                    label="Thin Word Position"
                    name="headerThinIndex"
                    type="number"
                    min="0"
                    step="1"
                    formik={formik}
                    value={formik.values.headerThinIndex || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.headerThinIndex && Boolean(formik.errors.headerThinIndex)}
                    errorMessage={formik.errors.headerThinIndex}
                  /> */}

                  {/* 
                  <SitesDropDown
                    name="siteIds"
                    label="Sites"
                    multiple={true}
                    formik={formik}
                    value={formik.values.siteIds}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.siteIds)}
                    errorMessage={formik.errors.siteIds}
                  /> */}

                  <TextField
                    label="Button URL"
                    name="website"
                    formik={formik}
                    value={formik.values.website || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.website && Boolean(formik.errors.website)}
                    errorMessage={formik.errors.website}
                  />

                  <TextField
                    label="Group name"
                    name="group"
                    formik={formik}
                    value={formik.values.group || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.group && Boolean(formik.errors.group)}
                    errorMessage={formik.errors.group}
                  />

                  <TextField
                    label="Button text"
                    name="buttonText"
                    formik={formik}
                    value={formik.values.buttonText || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.buttonText && Boolean(formik.errors.buttonText)}
                    errorMessage={formik.errors.buttonText}
                  />

                  <div className="color-grid">
                    <TextField
                      label="Button color"
                      name="buttonColor"
                      formik={formik}
                      value={formik.values.buttonColor || ''}
                      onChange={formik.handleChange}
                      error={formik.touched.buttonColor && Boolean(formik.errors.buttonColor)}
                      errorMessage={formik.errors.buttonColor}
                    />

                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: formik.values.buttonColor ? formik.values.buttonColor : 'white',
                      }}
                    ></div>
                  </div>

                  <div className="color-grid">
                    <TextField
                      label="Button text color"
                      name="buttonTextColor"
                      formik={formik}
                      value={formik.values.buttonTextColor || ''}
                      onChange={formik.handleChange}
                      error={formik.touched.buttonTextColor && Boolean(formik.errors.buttonTextColor)}
                      errorMessage={formik.errors.buttonTextColor}
                    />
                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: formik.values.buttonTextColor ? formik.values.buttonTextColor : '',
                      }}
                    ></div>
                  </div>

                  <TextField
                    label="Listing CTA Text"
                    name="moreInfoText"
                    formik={formik}
                    value={formik.values.moreInfoText || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.moreInfoText && Boolean(formik.errors.moreInfoText)}
                    errorMessage={formik.errors.moreInfoText}
                  />

                  <TextField
                    label="Google Analytics Tag"
                    name="googleAnalyticsTag"
                    formik={formik}
                    value={formik.values.googleAnalyticsTag || ''}
                    onChange={formik.handleChange}
                    error={formik.touched.googleAnalyticsTag && Boolean(formik.errors.googleAnalyticsTag)}
                    errorMessage={formik.errors.googleAnalyticsTag}
                  />

                  <div className="color-grid">
                    <TextField
                      label="Background color"
                      name="backgroundColor"
                      formik={formik}
                      value={formik.values.backgroundColor || ''}
                      onChange={formik.handleChange}
                      error={formik.touched.backgroundColor && Boolean(formik.errors.backgroundColor)}
                      errorMessage={formik.errors.backgroundColor}
                    />
                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: formik.values.backgroundColor ? formik.values.backgroundColor : '',
                      }}
                    ></div>
                  </div>

                  <div className="color-grid">
                    <TextField
                      label="Background text color"
                      name="backgroundTextColor"
                      formik={formik}
                      value={formik.values.backgroundTextColor || ''}
                      onChange={formik.handleChange}
                      error={formik.touched.backgroundTextColor && Boolean(formik.errors.backgroundTextColor)}
                      errorMessage={formik.errors.backgroundTextColor}
                    />
                    <div
                      className="color-preview"
                      style={{
                        backgroundColor: formik.values.backgroundTextColor ? formik.values.backgroundTextColor : '',
                      }}
                    ></div>
                  </div>

                  <TextField
                    label="HOTW Listing CTA Text"
                    name="seeInsideMessage"
                    formik={formik}
                    value={formik.values.seeInsideMessage}
                    onChange={formik.handleChange}
                    error={formik.touched.seeInsideMessage && Boolean(formik.errors.seeInsideMessage)}
                    errorMessage={formik.errors.seeInsideMessage}
                  />
                </Grid.Column>
              </Grid>
            </Form>

            <br />

            <Button
              content="Save"
              icon="save"
              positive
              type="submit"
              labelPosition="left"
              onClick={() => {
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    return toast.error('Please fix errors before saving');
                  }
                  formik.submitForm().then(res => {
                    window.location.href = '/firm';
                  });
                });
              }}
            />
          </Segment>
        </PageContainer>
      )}
    </Formik>
  );

  return <>{firm && firm.id && getPage()}</>;
};

const mapStateToProps = state => ({
  firms: selectors.firms.firms(state),
  firm: selectors.firms.current(state),
});

const mapDispatchToProps = dispatch => ({
  getFirmById: bindActionCreators(actions.firm.getFirmById, dispatch),
  updateFirm: bindActionCreators(actions.firm.updateFirm, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmPage);
